const { equals, forEach, prop, propEq, propOr } = require('ramda');
const { mapIndexed } = require('ramda-adjunct');
const { BLOCK_MAP, BLOCK_KEYS } = require('./documentHistoriesConstants');

const sectionLabelFromIndex = (index) => `Section ${index + 1}`;

// Single source of truth for widget placements, shared by the front (immediate
// widget-edit entries) and the back (rebuilding placements for session-stack and
// propagated entries). Collect every placement of widgetId across all sections and
// blocks of the document, flagging the origin one.
const buildWidgetPlacements = (pages = [], widgetId, originSectionIndex, originBlock) => {
  const placements = [];
  mapIndexed((section, sectionIndex) => {
    forEach((blockKey) => {
      const rows = propOr([], blockKey, section);
      forEach((row) => {
        const widgets = propOr([], 'widgets', row);
        forEach((w) => {
          if (propEq(widgetId, 'widgetId', w)) {
            placements.push({
              sectionLabel: sectionLabelFromIndex(sectionIndex),
              block: prop(blockKey, BLOCK_MAP),
              isOrigin: equals(sectionIndex, originSectionIndex) && equals(blockKey, originBlock)
            });
          }
        }, widgets);
      }, rows);
    }, BLOCK_KEYS);
  }, pages);
  return placements;
};

module.exports = {
  sectionLabelFromIndex,
  buildWidgetPlacements
};
